import { render, staticRenderFns } from "./UnidadeNegocioConfiguracion.vue?vue&type=template&id=4f8f7b49"
import script from "./UnidadeNegocioConfiguracion.vue?vue&type=script&lang=js"
export * from "./UnidadeNegocioConfiguracion.vue?vue&type=script&lang=js"
import style0 from "./UnidadeNegocioConfiguracion.vue?vue&type=style&index=0&id=4f8f7b49&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports